import { render, staticRenderFns } from "./Communicate.vue?vue&type=template&id=57e51f4c&scoped=true&"
import script from "./Communicate.vue?vue&type=script&lang=js&"
export * from "./Communicate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e51f4c",
  null
  
)

export default component.exports